import React from 'react';

import {ProteinComplex} from 'molbio/aa-sequences/complex/AaSequenceComplexConstants';
import formatAminoAcids from 'molbio/aa-sequences/util/formatAminoAcids';

export default function ProteinChainPreview({name, aminoAcids}: ProteinComplex): JSX.Element {
  return (
    <div>
      <div>
        <strong>{name}</strong>
      </div>
      <pre>{formatAminoAcids(aminoAcids)}</pre>
    </div>
  );
}
